import { render } from "./LoginButton.vue?vue&type=template&id=74f19ab7&ts=true"
import script from "./LoginButton.vue?vue&type=script&lang=ts"
export * from "./LoginButton.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__